module.exports = __webpack_public_path__ + "static/media/blank-avatar.77f5794e.png";